import { HttpClient } from '@/lib/http/http-client';

const client = new HttpClient('/api');

export const login = async (data: any): Promise<any> => {
    return client.post<any>('/login', data);
};
